module.exports = __webpack_public_path__ + "img/Lara_Diaz.e977abd6.jpg";